import React, { useState, useEffect, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { useReactToPrint } from "react-to-print";

// Components
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/CustomerConstants";
import ItemService from "../../../../services/supplier_appCommonService";

import {
  addcustomerID,
  getCustomerList,
  workflow,
} from "../../../../redux/feature/customer_app/customerSlice";

import { SearchField } from "../../../../Components/formElements/SearchField";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import { formatDate, formatDateTime } from "../../../../common/Validations";
import PrintGatePass from "./PrintGatePass";
import MultiColumnFilter from "../../../../Components/MultiColumnFilter/MultiColumnFilter";

const GateEntryInWordOutWardList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "GateEntry");
  localStorage.setItem("submenu", "Inward/Outward");

  let customerData = useSelector((state) => state?.customer);
  let customerTable = useSelector((state) => state?.customer.pagination);
  let config = useSelector((state) => state?.common?.data?.suppliers);

  let userData = useSelector((state) => state?.user); // User Details from Store

  const [userAllowed, setUserAllowed] = useState(false);

  useEffect(() => {
    if (userData?.data?.roles) {
      const allowedRoles = ["SALES-ADMIN", "SECURITY"];

      const isAllowed = userData.data.roles.some((r) =>
        allowedRoles.includes(r.roleId),
      );

      setUserAllowed(isAllowed);
    }
  }, [userData]);

  const [data, setData] = useState([]);
  const [isCardVisible, setCardVisible] = useState(true);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  const [filterShow, setFilterShow] = useState(false);

  // Print States
  const [printData, setPrintData] = useState(null);
  const [poItems, setPOItems] = useState([]);
  const printGatePassRef = useRef(null);
  const [activeFilters, setActiveFilters] = useState([]);
  const docNumberRef = useRef(""); //  Use ref instead of state for document number

  //  Filter configuration for Gate Entry

  const filterColumns = [
    {
      id: "gate",
      name: "Gate Type",
      selectorKey: "gate",
      dropDown: true,
    },
    {
      id: "purchasingDocumentNr",
      name: "PO Number",
      selectorKey: "purchasingDocumentNr",
    },
    {
      id: "inVehicleNumber",
      name: "Vehicle Number",
      selectorKey: "inVehicleNumber",
    },
  
    {
      id: "deliveryChallanNumber",
      name: "Delivery Challan No",
      selectorKey: "deliveryChallanNumber",
    },
    {
      id: "inCustomerName",
      name: "Customer Name",
      selectorKey: "inCustomerName",
    },
    {
      id: "inDriverName",
      name: "Driver Name",
      selectorKey: "inDriverName",
    },
    {
      id: "inDate",
      name: "Entry Date",
      selectorKey: "inDate",
      month: true,
    },
  ];

  //  Handle multi-column filter
  // const handleMultiColumnFilter = (filterResult) => {
  //   setFilterShow(false);

  //   let obj = {
  //     queryName: "getLogisticsGateEntryList",
  //     module: "",
  //     page: 1,
  //     per_page: 10,
  //     searchTerm: getCommonSearchTxt || "",
  //     timeZone: "Asia/Calcutta",
  //   };

  //   // Add filter if exists
  //   if (filterResult && filterResult.$and && filterResult.$and.length > 0) {
  //     obj.rowFilter = filterResult;
  //   }

  //   dispatch(getCustomerList(obj));
  // };
  const handleMultiColumnFilter = (filterResult) => {
    const filtersArray = Array.isArray(filterResult)
      ? filterResult
      : filterResult?.$and || [];

    setActiveFilters(filtersArray); // ← save filters

    const obj = {
      queryName: "getLogisticsGateEntryList",
      module: "",
      page: 1,
      per_page: getNewPerPage,
      searchTerm: getCommonSearchTxt || "",
      timeZone: "Asia/Calcutta",
      rowFilter: filtersArray.length > 0 ? { $and: filtersArray } : {},
    };
    dispatch(getCustomerList(obj));
  };
  //  Handle filter cancel
  // const handleFilterCancel = () => {
  //   setFilterShow(false);
  // };
  const handleFilterCancel = () => {
    setFilterShow(false);
    setActiveFilters([]); // ← clear filters
    dispatch(
      getCustomerList({
        queryName: "getLogisticsGateEntryList",
        module: "",
        page: 1,
        per_page: getNewPerPage,
        timeZone: "Asia/Calcutta",
      }),
    );
  };

  // Fetch PO Details with Line Items
  const fetchPODetails = async (poNumber) => {
    try {
      let obj = {
        module: "PO",
        queryName: "getMaterialPO",
        page: 1,
        per_page: 100,
        searchTerm: poNumber,
        timeZone: "Asia/Calcutta",
      };

      const response = await ItemService.getPurchaseOrder(obj);

      if (
        response?.status === 200 &&
        response?.data &&
        response.data.length > 0
      ) {
        const matchedPO = response.data.find(
          (po) =>
            po.purchasingDocumentNr === poNumber ||
            po.documentNumber === poNumber,
        );

        if (matchedPO && matchedPO.items) {
          return matchedPO.items;
        }
      }
      return [];
    } catch (error) {
      console.error("Error fetching PO details:", error);
      toast.error("Failed to fetch PO items", {
        duration: 2000,
        position: "top-right",
      });
      return [];
    }
  };
  const handlePrintGatePass = useReactToPrint({
    contentRef: printGatePassRef,
    documentTitle: `Gate_Pass_${docNumberRef.current}`, // Use ref value directly
    onAfterPrint: () => {
      toast.success("Gate Pass printed successfully!", {
        duration: 2000,
        position: "top-right",
      });
      setPrintData(null);
      setPOItems([]);
      docNumberRef.current = ""; // Clear ref
    },
  });

  //Trigger Print Function
  const triggerPrint = async (rowData) => {
    try {
      // Extract document number
      const docNumber =
        rowData?.documentNumber ||
        rowData?.gateEntrytNr ||
        rowData?.gateCode ||
        "GatePass";

      //  Store in ref (immediate, no state delay)
      docNumberRef.current = docNumber;
      setPrintData(rowData);

      // If InWard and has PO Number, fetch PO items
      if (rowData.gate === "InWard" && rowData.purchasingDocumentNr) {
        toast.loading("Fetching PO items...", {
          id: "fetch-po",
          duration: 1500,
        });

        const items = await fetchPODetails(rowData.purchasingDocumentNr);
        setPOItems(items);

        // Wait for state updates, then print
        setTimeout(() => {
          handlePrintGatePass();
        }, 200);
      } else {
        // No PO items needed, print directly
        setPOItems([]);
        setTimeout(() => {
          handlePrintGatePass();
        }, 200);
      }
    } catch (error) {
      console.error("Error in triggerPrint:", error);
      toast.error("Failed to print gate pass", {
        duration: 2000,
        position: "top-right",
      });
    }
  };

  const detailedPage = (customerID) => {
    dispatch(addcustomerID(customerID));
    navigate(Constants.CUSTOMER_V5_MR_LOGISTICS_GATE_ENTRY_UPDATE);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const loadInitialSuuplierData = async () => {
    setData(customerData?.data);
  };

  // const handlePageChange = (page) => {
  //   let obj = {
  //     queryName: "getLogisticsGateEntryList",
  //     module: "",
  //     page: page,
  //     per_page: getNewPerPage,
  //   };
  //   dispatch(getCustomerList(obj));
  //   setData(customerData?.data);
  // };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "getLogisticsGateEntryList",
      module: "",
      page: page,
      per_page: getNewPerPage,
      timeZone: "Asia/Calcutta",
      rowFilter: activeFilters.length > 0 ? { $and: activeFilters } : {}, // ← add
    };
    dispatch(getCustomerList(obj));
  };
  // const handlePerRowsChange = async (newPerPage, page) => {
  //   let obj = {
  //     queryName: "getLogisticsGateEntryList",
  //     module: "",
  //     page: page,
  //     per_page: newPerPage,
  //   };
  //   setNewPerPage(newPerPage);
  //   dispatch(getCustomerList(obj));
  //   setData(customerData?.data);
  // };
  const handlePerRowsChange = async (newPerPage, page) => {
    setNewPerPage(newPerPage);
    let obj = {
      queryName: "getLogisticsGateEntryList",
      module: "",
      page: page,
      per_page: newPerPage, // ← was missing newPerPage
      timeZone: "Asia/Calcutta",
      rowFilter: activeFilters.length > 0 ? { $and: activeFilters } : {}, // ← add
    };
    dispatch(getCustomerList(obj));
  };
  // const handleSearchFuncApi = async () => {
  //   let obj = {
  //     queryName: "getLogisticsGateEntryList",
  //     module: "",
  //     page: 1,
  //     per_page: 10,
  //     searchTerm: getCommonSearchTxt,
  //   };
  //   dispatch(getCustomerList(obj));
  // };
  const handleSearchFuncApi = async () => {
    setActiveFilters([]); // ← clear filters when searching
    let obj = {
      queryName: "getLogisticsGateEntryList",
      module: "",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
      timeZone: "Asia/Calcutta",
    };
    dispatch(getCustomerList(obj));
  };
  useEffect(() => {
    const fetchData = async () => {
      await loadInitialSuuplierData();
      dispatch(workflow({}));
    };

    fetchData();
    loadInitialSuuplierData();
    dispatch(workflow({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerData?.data]);

  useEffect(() => {
    dispatch(addcustomerID(""));
    let obj = {
      queryName: "getLogisticsGateEntryList",
      module: "",
      page: 1,
      per_page: 10,
    };
    dispatch(getCustomerList(obj));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const gateInwardOutWardInfo = [
    {
      name: "Gate Entry Number",
      selector: (row) => row?.documentNumber,
      cell: (row) => (
        <>
          <button
            className="btnInfo"
            onClick={() => detailedPage(row?.documentNumber)}
          >
            {row?.documentNumber || "-"}{" "}
          </button>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Entry Date",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{formatDate(row?.inDate)} </p>
        </div>
      ),
      width: "120px",
    },
    {
      name: "Entry Time",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.gateInwardSelectedTime} </p>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.gateOutWardTime} </p>
        </div>
      ),
      selector: (row) => row.salesOfficerName,
      sortable: true,
      width: "120px",
    },
    {
      name: "Purchase Order No",
      selector: (row) => row.purchasingDocumentNr,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.purchasingDocumentNr} </p>
        </div>
      ),
      sortable: true,
      width: "165px",
    },
    {
      name: "Gate",
      selector: (row) => row.gate,
      cell: (row) => <TableStatusField status={`${row?.gate}`} />,
      sortable: true,
      width: "140px",
    },
    {
      name: "Customer Name",
      cell: (row) => (
        <>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.inCustomerName} </p>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.outCustomerName} </p>
        </>
      ),
      selector: (row) => row.salesOfficerName,
      sortable: true,
      width: "180px",
    },
    {
      name: "Invoice Number",
      selector: (row) => row.invoiceNumber,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.invoiceNumber || "--"}</p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "E-way Bill No",
      selector: (row) => row.ewayBillNumber,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.ewayBillNumber || "--"}</p>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Delivery Challan No",
      selector: (row) => row.deliveryChallanNumber,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">
            {row.deliveryChallanNumber || "--"}
          </p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Gate Pass",
      cell: (row) => (
        <button className="btnTable" onClick={() => triggerPrint(row)}>
          <i className="bi bi-printer"></i> Print
        </button>
      ),
      width: "150px",
    },

    {
      name: "Vehicle No",
      selector: (row) => row.inVehicleNumber,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.inVehicleNumber}</p>
          <p className="m-0 p-0 pt-1 fw-bold">{row.outVehicleNumber}</p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Driver Details",
      cell: (row) => (
        <div style={{ fontSize: "13px" }}>
          {/* InWard */}
          {row.inDriverName && (
            <div className="mb-1">
              <div className="fw-bold">{row.inDriverName}</div>
              <div className="text-muted">
                {row.inDriverMobileNumber || "--"}
              </div>
            </div>
          )}

          {/* OutWard */}
          {row.outDriverName && (
            <div>
              <div className="fw-bold">{row.outDriverName}</div>
              <div className="text-muted">
                {row.outDriverMobileNumber || "--"}
              </div>
            </div>
          )}

          {!row.inDriverName && !row.outDriverName && "--"}
        </div>
      ),
      width: "180px",
    },
    // {
    //   name: "Driver Name",
    //   cell: (row) => (
    //     <>
    //       <TableStatusField
    //         status={`${row?.inDriverName || ""}  ${row?.outDriverName || ""}`}
    //       />
    //       <div>
    //       <p className="m-0 p-0 pt-1 fw-bold ">{row.inDriverMobileNumber} </p>
    //       <p className="m-0 p-0 pt-1 fw-bold ">{row.outDriverMobileNumber} </p>
    //     </div>
    //     </>
    //   ),
    //   width: "120px",
    // },
    // {
    //   name: "Driver Mobile No",
    //   selector: (row) => row.inDriverMobileNumber,
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1 fw-bold ">{row.inDriverMobileNumber} </p>
    //       <p className="m-0 p-0 pt-1 fw-bold ">{row.outDriverMobileNumber} </p>
    //     </div>
    //   ),
    //   sortable: true,
    //   width: "160px",
    // },

    {
      name: "Created",
      selector: (row) => formatDateTime(row.createdAt),
      sortable: true,
      width: "190px",
    },
    {
      name: "",
      selector: (row) => row.receivedBy,
      cell: (row) => (
        <>
          <span>{row.receivedBy}</span>
        </>
      ),
      sortable: true,
      width: "150px",
    },
  ];

  const showGateRequestModal = () => {
    navigate(Constants.CUSTOMER_V5_MR_LOGISTICS_CREATE_GATE_ENTRTY);
    // setModalGateShowStatus(true);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Gate Entry List</h2>
                <p className="subText">Gate Entry List </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={4} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col xs={12} md={12} lg={12}>
                {filterShow && (
                  <MultiColumnFilter
                    columns={filterColumns}
                    data={data}
                    onFilter={handleMultiColumnFilter}
                    onCancel={handleFilterCancel}
                    output="and"
                  />
                )}
              </Col>
            </Row>

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">GE</span>
                    </Col>
                    <Col xs={8} md={3} lg={3}>
                      <span className="headerTitle">Gate Entry</span>
                      <span className="subHeaderTitle">Gate</span>
                    </Col>

                    <Col xs={12} md={6} lg={6} className="headerButtonAlign">
                      {userAllowed && (
                        <Col xs={{ span: 4, offset: 8 }} md={2} lg={2}>
                          <button
                            className="btnTable"
                            onClick={() => showGateRequestModal()}
                          >
                            Create Gate Entry
                          </button>
                        </Col>
                      )}

                      {config?.filter && (
                        <Col xs={2} md={1} lg={1}>
                          <>
                            <div className="filter">
                              <span
                                className="icon hide headerIcon"
                                data-bs-toggle="dropdown"
                                aria-expanded="true"
                              >
                                <i className="bi bi-three-dots"></i>
                              </span>
                              <ul
                                className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                                data-popper-placement="bottom-end"
                              >
                                <li className="dropdown-header text-start">
                                  <h6>Menu</h6>
                                </li>

                                <li>
                                  <span
                                    className="dropdown-item headerIcon"
                                    onClick={() => handleSearchFuncApi()}
                                  >
                                    <i className="bi bi-arrow-clockwise"></i>
                                    Refresh Data
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </>
                        </Col>
                      )}
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={gateInwardOutWardInfo}
                          data={data}
                          progressPending={customerData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationPerPage={getNewPerPage}
                          paginationTotalRows={customerTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {/* Hidden Print Component */}
      <div style={{ display: "none" }}>
        {printData && (
          <PrintGatePass
            ref={printGatePassRef}
            data={printData}
            poItems={poItems}
          />
        )}
      </div>
    </main>
  );
};

export default GateEntryInWordOutWardList;
